import React, { useState, useRef, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ProgressBar, Image } from '@unimed-fesp/components';

import { Base64 } from 'js-base64';
import TipoTelefoneEnum from '../../enums/TipoTelefoneEnum';
import { setParamsTermoResponsabilidade } from '../../services/massaInicial';
import { OpenConnection, BuildConnection } from '../../services/signalR';
import UnimedLogo from '../../assets/images/login/logo-unimed-fesp.svg';

import { Creators as ListaActions } from '../../store/ducks/lista';

import SectionHeader from '../../components/atoms/SectionHeader';

import FormMassaInicial from '../../components/organisms/FormMassaInicial';
import ModalTermoMassaInicial from '../../components/organisms/ModalTermoMassaInicial';
import UploadMassaInicial from '../../components/organisms/UploadMassaInicial';

import {
  Container,
  ContainerFormMassaInicial,
  HeaderContainer,
  ImageBackground,
  ContainerImage,
  HeaderTitulo,
  ContainerProgressBar,
  TextoPasso,
  Form,
} from './styles';

const inicalValuesForm = {
  empresa: '',
  cnpj: '',
  responsavel: '',
  email: '',
  telefone: {
    contatos: [
      {
        tipo: 'Celular',
        numero: '',
      },
    ],
  },
};
const passos = ['Dados da empresa', 'Importar massa inicial'];

function MassaInicial() {
  const [dadosEmpresa, setDadosEmpresa] = useState(inicalValuesForm);
  const [fileMassaInicial, setFileMassaInicial] = React.useState([]);
  const [signalRConnection, setSignalRConnection] = useState();
  const [termosAceitos, setTermosAceitos] = useState([]);
  const [progress, setProgress] = useState(0);

  const { idLista } = useSelector((state) => state.lista.MassaInicial.post);
  const formRef = useRef();
  const [termoOpen, setTermoOpen] = useState(false);
  const [passo, setPasso] = useState(0);

  const dispatch = useDispatch();

  const clearInputs = () => {
    setDadosEmpresa(inicalValuesForm);
  };

  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsText(file, 'ISO-8859-1');
      reader.onload = (e) => {
        resolve(Base64.encode(e.target.result));
      };
      reader.onerror = (error) => reject(error);
    });

  const formatBody = async (files, idHub) => {
    const { file } = files[0];

    const [, nomeArquivo, extensao] = new RegExp(/(.*?)\.([^.\\]+)$/gm).exec(
      file.name
    );
    const { telefone } = dadosEmpresa;

    const contato =
      telefone.contatos.length > 0 && telefone.contatos[0].numero.length > 0
        ? {
            ddd: telefone.contatos[0].numero.substr(0, 2),
            numero: telefone.contatos[0].numero.substr(2),
            tipo: TipoTelefoneEnum.returnNameForName[telefone.contatos[0].tipo],
          }
        : {};

    const cnpj = dadosEmpresa.cnpj
      ? dadosEmpresa.cnpj.replaceAll(/[^\d]/g, '')
      : null;

    const tempBody = {
      nomeEmpresa: dadosEmpresa.empresa,
      cnpj,
      nomeResponsavel: dadosEmpresa.responsavel,
      email: dadosEmpresa.email,
      contato,
      arquivo: await toBase64(file),
      nomeArquivo,
      extensaoArquivo: `.${extensao}`,
      idHub: idHub || 0,
    };

    return tempBody;
  };

  const handleValidadMassaInicial = useCallback(
    async (files, idHub) => {
      const body = await formatBody(files, idHub);
      dispatch(ListaActions.postArquivoMassaInicialRequest(body));
    },
    [dispatch, formatBody]
  );

  async function SignalRUploadProgress() {
    const socketConnection = BuildConnection('ProgressStatusHub');
    socketConnection.on('updateProgress', (message) => {
      if (!message.errorMessage && message.progressValue !== 0)
        setProgress(message.progressValue);
    });
    await OpenConnection(socketConnection);
    setSignalRConnection(socketConnection);

    return socketConnection;
  }

  function handleChange(files) {
    if (files.length <= 0) {
      setFileMassaInicial([]);
      return;
    }

    SignalRUploadProgress().then((conn) => {
      setSignalRConnection(conn);
      setFileMassaInicial(files);
      if (files.length > 0) handleValidadMassaInicial(files, conn.connectionId);
    });
  }

  function handleTermoResponsabilidade() {
    const body = {
      aceiteCompartilhamento: termosAceitos.includes('compartilhar'),
      aceiteTermo: termosAceitos.includes('termo'),
    };
    dispatch(
      ListaActions.patchAceiteCompartilhamentoMassaInicialRequest(idLista, body)
    );
  }

  function handleVoltarPasso() {
    setPasso(passo - 1);
    setTermosAceitos([]);
    dispatch(ListaActions.postArquivoMassaInicialRenew());
    dispatch(ListaActions.patchAceiteCompartilhamentoMassaInicialRenew());
  }

  useEffect(() => {
    setParamsTermoResponsabilidade({
      empresa: dadosEmpresa.empresa,
      responsavel: dadosEmpresa.responsavel,
    });
  }, [dadosEmpresa]);

  return (
    <Container>
      <ContainerImage>
        <HeaderContainer>
          <Image marginBottom="10px" src={UnimedLogo} name="Unimed Logo" />
          <SectionHeader
            sectionName="movcad"
            subtextSectionName="movimentações cadastrais"
            padding="0px"
          />
        </HeaderContainer>
        <ImageBackground />
      </ContainerImage>
      <ContainerFormMassaInicial>
        <HeaderTitulo>massa inicial</HeaderTitulo>
        <Form ref={formRef}>
          <ContainerProgressBar>
            <ProgressBar completed={(passo + 1) * 50} width={500} />
            <TextoPasso>
              Passo {passo + 1} de 2: {passos[passo]}
            </TextoPasso>
          </ContainerProgressBar>
          {passo === 0 && (
            <FormMassaInicial
              dadosEmpresa={dadosEmpresa}
              setDadosEmpresa={setDadosEmpresa}
              formRef={formRef.current}
              clearInputs={clearInputs}
              handleAvancar={() => setPasso(passo + 1)}
            />
          )}
          {passo === 1 && (
            <UploadMassaInicial
              handleVoltar={handleVoltarPasso}
              setListaFiles={handleChange}
              file={fileMassaInicial[0] || null}
              progress={progress}
              handleValidar={() => {
                setTermoOpen(true);
              }}
            />
          )}
        </Form>
      </ContainerFormMassaInicial>
      <ModalTermoMassaInicial
        isOpen={termoOpen}
        onClick={() => setTermoOpen(false)}
        aceitos={termosAceitos}
        setAceitos={setTermosAceitos}
        handleValidadMassaInicial={handleTermoResponsabilidade}
      />
    </Container>
  );
}

export default MassaInicial;
